import { render } from "./AddMenu.vue?vue&type=template&id=21ac81aa&scoped=true&ts=true"
import script from "./AddMenu.vue?vue&type=script&lang=ts"
export * from "./AddMenu.vue?vue&type=script&lang=ts"

import "./AddMenu.vue?vue&type=style&index=0&id=21ac81aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ac81aa"]])

export default __exports__